import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.scss';
import useLanguage from '../../../hooks/useLanguage';

import ArrowRight from '../../../svg/arrow_right.svg';
import ArrowLeft from '../../../svg/arrow_left.svg';

const StepsSlider = ({ items }) => {
  const langToggle = useLanguage;

  const items_size = 3;
  const sliced_items = [];
  for (let i = 0; i < items.length; i += items_size) {
    sliced_items.push(items.slice(i, i + items_size));
  }
  // console.log(sliced_items);

  const slider = React.createRef();

  const [currentSlide, setCurrentSlide] = React.useState(0);
  const counter = currentSlide + 1;

  function handleAfterChange(index) {
    setCurrentSlide(index);
  }

  function SampleNextArrow() {
    return (
      <button
        className="slider-button slider-button__next"
        onClick={() => slider.current.slickNext()}
      >
        Next
        <ArrowRight className="slider-button__arrow" />
      </button>
    );
  }

  function SamplePrevArrow() {
    return (
      <button
        className={'slider-button slider-button__prev'}
        onClick={() => slider.current.slickPrev()}
      >
        Prev
        <ArrowLeft className="slider-button__arrow" />
      </button>
    );
  }

  var settings = {
    // fade: true,
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    afterChange: handleAfterChange,
    // responsive: [
    //   {
    //     breakpoint: 767,
    //     settings: 'unslick',
    //   },
    // ],
  };

  return (
    <div className="steps-slider__wrapper">
      <Slider ref={slider} {...settings} className={'steps-slider'}>
        {sliced_items.map((slide, index) => {
          return (
            <div className="slide" key={index}>
              <div className="slide-wrapper__overflow">
                {slide.map((item, index) => {
                  return (
                    <div className="slide-wrapper" key={index}>
                      <span className="slide-marker">
                        {langToggle(item.marker_ua, item.marker_ru)}
                      </span>
                      <p className="slide-title">
                        {langToggle(item.title_ua, item.title_ru)}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </Slider>
      <div className="steps-slider__nav">
        <div className="steps-slider__counter">
          <span className="steps-slider__counter-current">
            {counter <= 9 ? '0' + counter : counter}
          </span>
          <span className="steps-slider__counter-separator">/</span>
          <span className="steps-slider__counter-total">
            {sliced_items.length <= 9
              ? '0' + sliced_items.length
              : sliced_items.length}
          </span>
        </div>
        <div className="steps-slider__buttons">
          <SamplePrevArrow />
          <SampleNextArrow />
        </div>
      </div>
    </div>
  );
};

StepsSlider.propTypes = {
  items: PropTypes.array,
};

export default StepsSlider;
